const purplePurple = require("../assets/humanitixLogos/purple_purple.svg");
const whiteTeal = require("../assets/humanitixLogos/white_teal.svg");

const LogoServices = {
  getLogo(logo) {
    switch (logo) {
      case "purplePurple":
        return purplePurple;
      case "whiteTeal":
        return whiteTeal;
      default:
        return purplePurple;
    }
  }
};

export default LogoServices;
